import { LoginService, StatisticService } from '@pxl/models/contracts';
import { inject, Injectable } from '@angular/core';
import { StatisticService as StatisticBackendService, StatisticWriteBody } from '@pxl/shared/generated';
import { Observable } from 'rxjs';
import { CONFIG_TOKEN } from '@pxl/models/common';
@Injectable()
export class DefaultStatisticService implements StatisticService {
    private readonly statisticBackendService = inject(StatisticBackendService);
    private readonly config = inject(CONFIG_TOKEN);
    private readonly loginService = inject(LoginService);

    public writeStatisticData(data: StatisticWriteBody): Observable<void> {
        return this.statisticBackendService.writeStatisticData(data, this.config.API_VERSION, this.loginService.getToken());
    }
}
